import { AssetRegistersContextMenu } from "../register-actions/register-actions.runtime"
import { RemoveRegisterMenuItem } from "./remove-register-menu-item"

AssetRegistersContextMenu.plug(<RemoveRegisterMenuItem priority={40} />)
